import React from 'react';


export default function StateView(props){

    const {states,activeState} = props;

    const currentStateInfos = React.useMemo(()=>{
        const foundedState = states.find(state=>state.state == activeState);

        return foundedState;
    },[activeState]);

    return (
        <div className={`label label-lg py-8 font-weight-bold label-inline ${currentStateInfos?.classes}`} style={{...currentStateInfos?.styles,whiteSpace: 'nowrap',width: '100%'}}>
            {currentStateInfos?.label}

            {
                !activeState && (
                    'Demande incomplète'
                )
            }
        </div>
    );
}